import { FC } from "react"
import { KTSVG } from "../../../_metronic/helpers"

type Props = {
    status? : string
}

export const StatusErrorMessage: FC<Props> = ( {status}) => (
    <>
    {status &&
    <div className='alert alert-danger d-flex flex-row align-items-center gap-2 py-1 my-1 fs-7'>
        <KTSVG path='/media/icons/duotune/abstract/abs012.svg' className='svg-icon-1 svg-icon-danger' />
        <div className='alert-text font-weight-bold'>{status}</div>
    </div>
    }    
    </>
)

